import React from 'react';
import { Building2, Users, GraduationCap, BookOpen, Activity } from 'lucide-react';
import type { Activity as ActivityType } from '../../../services/dashboardService';

interface ActivityItemProps {
  activity: ActivityType;
}

const ActivityItem: React.FC<ActivityItemProps> = ({ activity }) => {
  const getActivityIcon = (type: string) => {
    switch (type) {
      case 'school':
        return <Building2 className="h-4 w-4 text-blue-500" />;
      case 'class':
        return <BookOpen className="h-4 w-4 text-green-500" />;
      case 'teacher':
        return <GraduationCap className="h-4 w-4 text-purple-500" />;
      case 'student':
        return <Users className="h-4 w-4 text-orange-500" />;
      default:
        return <Activity className="h-4 w-4 text-gray-500" />;
    }
  };

  const getActivityColor = (type: string) => {
    switch (type) {
      case 'school':
        return 'bg-blue-100 text-blue-800';
      case 'class':
        return 'bg-green-100 text-green-800';
      case 'teacher':
        return 'bg-purple-100 text-purple-800';
      case 'student':
        return 'bg-orange-100 text-orange-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getTypeLabel = (type: string) => {
    switch (type) {
      case 'school':
        return 'Trường học';
      case 'class':
        return 'Lớp học';
      case 'teacher':
        return 'Giáo viên';
      case 'student':
        return 'Học sinh';
      default:
        return type;
    }
  };

  const formatTimeAgo = (timestamp: string) => {
    const now = new Date();
    const time = new Date(timestamp);
    const diffInHours = Math.floor((now.getTime() - time.getTime()) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return 'Vừa xong';
    if (diffInHours < 24) return `${diffInHours} giờ trước`;
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays} ngày trước`;
  };

  return (
    <div className="flex items-start space-x-3">
      <div className="flex-shrink-0 mt-1">
        {getActivityIcon(activity.type)}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm text-gray-900">
          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium mr-2 ${getActivityColor(activity.type)}`}>
            {getTypeLabel(activity.type)}
          </span>
          {activity.description}
        </p>
        <p className="text-xs text-gray-500 mt-1">
          {formatTimeAgo(activity.timestamp)} • {activity.user}
        </p>
      </div>
    </div>
  );
};

export default ActivityItem;
